import { useContext } from 'react';
import { KlsContext } from '../context';
import { NotWrappedError } from '../functions';
var useKls = function () {
    var context = useContext(KlsContext);
    if (context === null)
        throw new NotWrappedError();
    return context;
};
export default useKls;
//# sourceMappingURL=useKls.js.map